{
  "next": "Sonraki",
  "previous": "Önceki"
}
